module.exports = "pegasus_template/assets/sandwich-bg.png";